import { render, staticRenderFns } from "./AlarmInfo.vue?vue&type=template&id=3da544d4&scoped=true"
import script from "./AlarmInfo.vue?vue&type=script&lang=js"
export * from "./AlarmInfo.vue?vue&type=script&lang=js"
import style0 from "./AlarmInfo.vue?vue&type=style&index=0&id=3da544d4&prod&lang=scss"
import style1 from "./AlarmInfo.vue?vue&type=style&index=1&id=3da544d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da544d4",
  null
  
)

export default component.exports